export default __webpack_public_path__ + "static/media/the-hatchening-poster.f84b7e8d.jpg";